module.exports = __webpack_public_path__ + "img/9.2a512f39.jpg";